import React, { useState } from 'react';
import classnames from 'classnames';
import { Formik, Form } from 'formik';

import Input from 'components/UI/InputFormik';
import Button from 'components/UI/Button';
import Checkbox from 'components/UI/Checkbox';

import validationSchema from './validationSchema';

import * as styles from './form-elem.module.scss';

const FormElem = ({ data, onSubmit }) => {
  const {
    subscribeFormFullAdditionalText,
    subscribeFormFullCheckboxField,
    subscribeFormFullInputLabel,
    subscribeFormFullTextInButton,
  } = data;

  const LABELS = {
    input_label: subscribeFormFullInputLabel,
    button: subscribeFormFullTextInButton,
    additional: subscribeFormFullAdditionalText,
    checkbox_txt: subscribeFormFullCheckboxField,
  };

  const [isActiveTextarea, setIsActiveTextarea] = useState(false);

  const handleSubmit = (values) => {
    if (onSubmit) onSubmit(values);
  };

  return (
    <Formik
      initialValues={{
        email: '',
      }}
      validationSchema={validationSchema()}
      onSubmit={(values, { setSubmitting }) => {
        setTimeout(() => {
          setSubmitting(false);
          handleSubmit(values);
        }, 400);
      }}
    >
      {({ values, setFieldValue, errors }) => {
        return (
          <Form className={styles.form} noValidate>
            <p className={'scr-txt-up scr-small'}>
              {LABELS.input_label}
              <span className={'scr-red'}>*</span>
            </p>

            <div className={classnames(styles.form_inner)}>
              <Input
                name="email"
                type="email"
                // label={labels.email}
                // placeholder={labels.input_placeholder}
                requiredField={true}
                className={classnames(
                  styles.form_field
                  // 'scr-transparent-input'
                )}
              />

              <Button
                type="submit"
                className={classnames(styles.form_submit, {
                  [styles.disable]: !isActiveTextarea,
                })}
              >
                {LABELS.button}
              </Button>
            </div>

            <Checkbox
              name="newsletter"
              className={styles.form_checkbox}
              onClick={() => setIsActiveTextarea(!isActiveTextarea)}
            >
              {LABELS.checkbox_txt}
            </Checkbox>

            <p className={classnames(styles.additional, 'scr-small')}>
              {LABELS.additional}
            </p>
          </Form>
        );
      }}
    </Formik>
  );
};

export default FormElem;
